/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Form, Radio, Row } from "antd";
import { InputField, InputPhone } from "../../../../../atoms/FormFields";
import { AutoCompleteField } from "../../../../../atoms/FormFields/AutoComplete";
import { AddressComponent, Place } from "../../../../Company/ducks/types";
import { SelectFieldTags } from "../../../../../atoms/FormFields/SelectFieldTags";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
// import AddContact from "../../AddContact";
import SuccessMessage from "../../../../../atoms/Toasts/SuccessMessage";
import { updateClientById } from "../../../ducks/services";
import { AxiosError } from "axios";
import ErrorMessage from "../../../../../atoms/Toasts/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { GetClientType } from "../../../ducks/types";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { getCompanyFieldsById } from "../../../../CompanySettings/TagsCategories/ducks/actions";
import AddContact from "../../../Components/AddContact";

interface CategoryType {
  label: string;
  value: string;
  color: string;
}

interface FormValues {
  first_name: string;
  last_name: string;
  title: string;
  address: string;
  email: string;
  phone: string;
  category_ids: string;
  company_name: string;
  companyAddress: string;
  companyCategoryIds: string;
  preferred_method_of_contact: string;
}

interface PropsType {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  companyId: string;
  clientId: string;
  clientDetailData: GetClientType | null;
}

interface PopUpFormValues {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  title: string;
  preferred_method_of_contact: string;
}

export default function ClientIndividual(props: PropsType) {
  const { setLoading, companyId, clientId, clientDetailData } = props;
  const [contacts, setContacts] = useState<PopUpFormValues[]>([]);
  const [method, setMethod] = useState("any");
  const dispatch = useAppDispatch();
  const [categoryDropDown, setCategoryDropDown] = useState<CategoryType[]>([]);
  const [googleAddress, setGoogleAddress] = useState<Place | null>(null);

  const tagItems = useAppSelector((state) => state?.tags?.tagData);

  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
        module: "CLIENTS",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId]);

  useEffect(() => {
    if (tagItems?.data && tagItems?.data?.length > 0) {
      const dummyArray: CategoryType[] = [];
      tagItems?.data?.map((item: { name: string; id: string; color: string }) =>
        dummyArray.push({
          label: item?.name,
          value: item?.id,
          color: item?.color,
        })
      );
      setCategoryDropDown(dummyArray);
    } else {
      setCategoryDropDown([]);
    }
  }, [tagItems]);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormValues>();

  const navigate = useNavigate();

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    let city = "";
    let state = "";
    googleAddress?.address_components?.forEach(
      (component: AddressComponent) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.short_name;
        }
      }
    );

    const payload = {
      name: val?.first_name?.trim(),
      last_name: val?.last_name?.trim(),
      address: val?.address,
      city: city,
      state: state,
      type: "individual",
      category_ids: val?.category_ids,
      phone: val?.phone,
      email: val?.email,
      title: val?.title,
      company_id: companyId,
      contact: contacts,
      preferred_method_of_contact: method,
    };

    updateClientById(clientId, payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Client individual updated");
        navigate(`/clients/${companyId}`);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  useEffect(() => {
    if (clientDetailData) {
      setValue("first_name", clientDetailData?.name);
      if (clientDetailData?.last_name) {
        setValue("last_name", clientDetailData?.last_name);
      }
      if (clientDetailData?.title) {
        setValue("title", clientDetailData?.title);
      }
      if (clientDetailData?.phone) {
        setValue("phone", clientDetailData?.phone);
      }
      if (clientDetailData?.email) {
        setValue("email", clientDetailData?.email);
      }
      if (clientDetailData?.preferred_method_of_contact) {
        setMethod(clientDetailData?.preferred_method_of_contact);
      }
      setValue("category_ids", clientDetailData?.category_ids);
      setValue("address", clientDetailData?.address);

      if (clientDetailData?.clientContacts?.length > 0) {
        setContacts(clientDetailData?.clientContacts);
      }
    }
  }, [clientDetailData, setValue]);

  return (
    <Form
      className="clientsForm"
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <Card style={{ paddingTop: "40px" }}>
        <Row gutter={8}>
          <Col span={12}>
            <InputField
              fieldName="first_name"
              label="First name"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "First name",
              }}
              isRequired
              rules={{
                required: "First name is required.",
              }}
              validate={errors.first_name && "error"}
              validMessage={errors.first_name && errors.first_name.message}
            />
          </Col>
          <Col span={12}>
            <InputField
              fieldName="last_name"
              label="Last name"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Last name",
              }}
              isRequired
              rules={{
                required: "Last name is required.",
              }}
              validate={errors.last_name && "error"}
              validMessage={errors.last_name && errors.last_name.message}
            />
          </Col>
          <Col span={24}>
            <InputField
              fieldName="title"
              label="Title"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Enter title",
              }}
              isRequired
              rules={{
                required: "title is required.",
              }}
              validate={errors.title && "error"}
              validMessage={errors.title && errors.title.message}
            />

            <AutoCompleteField
              fieldName="address"
              label="Billing address"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Search address",
              }}
              onPlaceChange={(place: Place) => setGoogleAddress(place)}
              tooltipTitle="This is where invoices or payment statements are sent."
            />
          </Col>
          <Col span={12}>
            <InputPhone fieldName="phone" label="Phone" control={control} />
          </Col>
          <Col span={12}>
            <InputField
              fieldName="email"
              label="Email"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Enter email",
                autoComplete: "email",
                maxLength: 100,
              }}
              isRequired
              rules={{
                required: "Email address is required.",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address.",
                },
              }}
              validate={errors.email && "error"}
              validMessage={errors.email && errors.email.message}
            />
          </Col>
          <Col span={24} style={{ display: "flex", marginBottom: "16px" }}>
            <div style={{ fontWeight: "500" }}>
              Preferred method of contact:
            </div>
            <div className="preferredMethodRadio">
              <Radio.Group
                onChange={(e) => setMethod(e.target.value)}
                value={method}
              >
                <Radio value="any">Any</Radio>
                <Radio value="phone">Phone</Radio>
                <Radio value="email">Email</Radio>
              </Radio.Group>
            </div>
          </Col>
          <Col span={24}>
            <SelectFieldTags
              fieldName="category_ids"
              label="Categories"
              control={control}
              selectOption={categoryDropDown}
              className="bottom_0"
              iProps={{
                placeholder: "Select categories",
                mode: "multiple",
              }}
            />
          </Col>
        </Row>
      </Card>

      <Card>
        <AddContact setContacts={setContacts} contacts={contacts} />
      </Card>

      <div className="fixed_btm_card">
        <Card>
          <div className="centered">
            <Button
              htmlType="button"
              className="outlined-btn"
              onClick={() => navigate(`/clients/${companyId}`)}
            >
              Cancel
            </Button>
            <div style={{ display: "flex", gap: "16px" }}>
              <Button htmlType="submit" type="primary" className="mint-btn">
                Save & close
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Form>
  );
}
